import React from 'react'
import BottomCard from './EnterPrise/BottomCard'
import SupportFeatureCard from './EnterPrise/SupportFeatureCard'
import TrainingSupportFeatureCard from './EnterPrise/TrainingSupportFeatureCard'
import ReviewCard from './EnterPrise/ReviewCard'
import EnterpriseFeatures from './EnterPrise/EnterpriseFeatures'
import EnterpriseAdsFeatures from './EnterPrise/EnterpriseAdsFeatures'
import IntegrationsAdsCard from './EnterPrise/IntegrationsAdsCard'
import CustomizingFeatures from './EnterPrise/CustomizingFeatures'
import TermOptions from './EnterPrise/TermOptions'
import HeroBanner from './EnterPrise/HeroBanner'
import EnterpriseComingSoon from './EnterPrise/EnterpriseComingSoon'

const EnterPrisePricing = () => {
  return (
    <div className=" w-dull flex flex-col gap-10">
      <EnterpriseComingSoon />
      {/* <HeroBanner /> */}
      {/* <EnterpriseAdsFeatures />
      <EnterpriseFeatures />
      <IntegrationsAdsCard />
      <SupportFeatureCard />
      <TrainingSupportFeatureCard />
      <CustomizingFeatures />
      <TermOptions />
      <ReviewCard />
      <BottomCard /> */}
    </div>
  )
}

export default EnterPrisePricing
